function experiment(window) {
  const getRunningExperiments = () => {
    const { rendererModel, editorModel = {} } = window
    return (rendererModel || editorModel).runningExperiments
  }

  const transformRunningExperiments = runningExperiments => Object.keys(runningExperiments).reduce((acc, key) => {
    acc[key.toLowerCase()] = runningExperiments[key]
    return acc
  }, {})

  let rawRunningExperiments
  let transformedRunningExperiments
  function getValue(name) {
    const runningExperiments = getRunningExperiments()
    if (rawRunningExperiments !== runningExperiments) {
      rawRunningExperiments = runningExperiments
      transformedRunningExperiments = transformRunningExperiments(runningExperiments)
    }
    return transformedRunningExperiments[name.toLowerCase()]
  }

  const isOpen = name => getValue(name) === 'new'

  function isMultiValueExperimentOpen(name) {
    const value = getValue(name)
    return value && value !== 'old'
  }

  return {
    getRunningExperiments,
    isOpen,
    getValue,
    isMultiValueExperimentOpen
  }
}

function defineExperiment(window) {
  if (window.define) {
    window.define('experiment', [], () => experiment(window))
  }
}

export {
  experiment,
  defineExperiment
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/experiment.js